import store from '@/xreports/store/index'
import { RouterService } from 'voc-service'
import Vue from 'vue'

async function checkAuthority(next, path) {
  try {
    await store.dispatch('systemUser/checkLogin')
    await store.dispatch('menus/initMenuList')
    // 验证完登录以后替换掉 url 上的 ticket 防止重复使用
    next(path.replace('ticket=', 'void='))
  } catch (error) {
    console.error(error)
    store.dispatch('systemUser/logout')
  }
}

const routerService = new RouterService()

export default router => {
  router.beforeEach((to, from, next) => {
    // 配合级联云国际化配置修改
    routerService.beforeEach({ to, Vue })
    const res = new RegExp('/en-US/')
    if (res.test(to.path)) {
      next({ path: to.path.replace(res, ''), query: to.query })
      return
    }
    // 白名单页面,直接跳转
    const whites = ['/system/login', '/system/logout']
    if (whites.includes(to.path)) {
      next()
      return
    }
    // 菜单已经初始化
    if (store.state.menus.initialized) {
      next()
      return
    }

    // 检查登录
    checkAuthority(next, to.fullPath)
  })
}
